ScoreTrekBattle.Translator = (function() {
    var _this, htmlEscape;

    htmlEscape = {
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;'
    };

    function getTranslation(text, isRaw) {
		let translation, path, segment, obj, translated;

        translated = false;

        if (ScoreTrekBattle.I18N.hasOwnProperty(text)) {
            translation = ScoreTrekBattle.I18N[text];
            translated = true;
        } else {
            //find text in language tree (id given as path1/path2/item)
            path = text.split('/');
            obj = ScoreTrekBattle.I18N;
            while (path.length > 0) {
                segment = path.shift();
                if (obj.hasOwnProperty(segment)) {
                    obj = obj[segment];
                } else {
                    obj = false;
                    break;
                }
            }
            if (obj !== false) {
                translation = obj;
                translated = true;
            }
        }
        if (!translated) {
            console.warn(`Missing translation: ${text}`);
            translation = text;
        }

        if (!isRaw && ((typeof translation === 'object') || Array.isArray(translation))) {
            console.warn(`Incomplete translation path: ${text}`);
            translation = text;
        }

        return translation;
    }

	function translateText(translationKey, translationVars, escapeHTML) {
        let text;

		text = String(translationKey).trim();

        if (text === '') {
            return '';
        }

        text = getTranslation(text);

        if (translationVars) {
            Object.keys(translationVars).forEach(placeholder => {
                let replacement;

                replacement = String(translationVars[placeholder]);
                if  (escapeHTML) {
                    replacement = _this.escapeHTML(replacement);
                }
                text = text.split(`{{${placeholder}}}`).join(replacement);
            });
        }

		return text;
	}

    function translateElement(element) {
        String(element.dataset.i18n).split(',').forEach(i18nElement => {
            var i18nElementParts, translationAttr, translationKey, translation;

            i18nElementParts = i18nElement.trim().split(':');
            translationKey = i18nElementParts.pop();
            translationAttr = i18nElementParts.pop();

            translation = translateText(translationKey, {
                appUrl: ScoreTrekBattle.ENV.APP,
                helpUrl: ScoreTrekBattle.ENV.HELP
            });

            if (translationAttr) {
                element.setAttribute(translationAttr, translation);
            } else {
                element.innerHTML = translation;
            }
        });
    }

    _this = {
        get: function(translationKey) {
            return getTranslation(translationKey, true);
        },
        i18n: function(translationKey, translationVars, escapeHTML) {
            return translateText(translationKey, translationVars, escapeHTML);
        },
        $i18n: function($element) {
            if ($element.get(0).dataset.hasOwnProperty('i18n')) {
                translateElement($element.get(0));
            } else {
                $element.find('[data-i18n]').each(function() {
                    translateElement(this);
                });
            }
        },
        escapeHTML: function(text) {
            text = String(text);
            Object.keys(htmlEscape).forEach(char => {
                text = text.split(char).join(htmlEscape[char]);
            });
            return text;
        },
        addHyperlinks: function(text, linkClass) {
            if (!text) {
                return '';
            }
            text = String(text).trim();
            linkClass = `${String(linkClass || '')} text-no-wrap`.trim();

            // http(s)-Links
            text = text.replace(
                /https?:\/\/[^\s<>()]+/g,
                rawUrl => {
                    const match = rawUrl.match(/^(.*?)([.,;!?")\]]*)$/);
                    const cleanedUrl = match[1];
                    const trailing = match[2];
                    return `<a href="${cleanedUrl}" target="_blank"${linkClass ? ` class="${linkClass}"` : ''}><i class="fa-solid fa-up-right-from-square"></i> <span class="text-wrap">${cleanedUrl}</span></a>${trailing}`;
                }
            );

            // e-mail addresses
            text = text.replace(/([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g, `<a href="mailto:$1"${linkClass ? ` class="${linkClass}"` : ''}><i class="fa-solid fa-envelope"></i> $1</a>`);

            return text;
        }
    };

    window.__i18n = _this.i18n;
    window.__$i18n = _this.$i18n;
    window.__escapeHTML = _this.escapeHTML;
    window.__addHyperlinks = _this.addHyperlinks;

    return _this;
})();
